var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7253 19.2479L29.116 28.3059L14.7253 13.9102L0 28.3059L14.7253 19.2479Z",
    fill: "url(#paint0_linear_584_2811)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.116 28.3058H0L14.725 24.4238L29.116 28.3058Z",
    fill: "url(#paint1_linear_584_2811)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7253 6.79352L29.116 28.3063L14.7253 0L0 28.3063L14.7253 6.79352Z",
    fill: "url(#paint2_linear_584_2811)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_584_2811",
    x1: 14.6146,
    y1: 5.99442,
    x2: 14.6146,
    y2: 23.3784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C30280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A2CC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_584_2811",
    x1: 14.6146,
    y1: 22.7787,
    x2: 14.6146,
    y2: 29.3726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C30280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052DB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_584_2811",
    x1: 14.558,
    y1: 2.67508e-9,
    x2: 14.6146,
    y2: 22.9788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C30280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#811DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo0);
export default __webpack_public_path__ + "static/media/logo0.e5e87bbe2937d783da042b3435bf9f09.svg";
export { ForwardRef as ReactComponent };